module.exports = __webpack_public_path__ + "img/japan-cerebrovascular-disease-female.8d627872.png";